import {
    scan,
    merge,
    mapTo,
    first,
    filter,
    takeUntil,
    startWith,
    switchMapTo,
} from 'rxjs/operators';

const createTimer = (
    start$,
    pause$,
    stop$,
    interval$,
    maxDurationInSeconds,
) => {
    const initialState = 0;
    const increment = prev => prev + 1;
    const reset = () => initialState;

    const shouldFreeze$ = pause$.pipe(merge(stop$));
    const shouldStop$ = stop$.pipe(mapTo(reset));
    const shouldIncrement$ = interval$
        .pipe(
            takeUntil(shouldFreeze$),
            mapTo(increment)
        );

    const incrementOrStop = shouldIncrement$.pipe(merge(shouldStop$));

    return start$
        .pipe(
            switchMapTo(incrementOrStop),
            startWith(initialState),
            scan((prev, increment) => increment(prev)),
            filter(current => current >= maxDurationInSeconds),
            first()
        );
};

export default createTimer;
